import React from 'react';
import PropTypes from 'prop-types';

const IntroCards = (props) => {
  return (
    <div className="intro-card">
      <h3 className="heading medium-font">
        <span className="red" id="intro-heading">{props.headingRed}</span>
        &nbsp;
        <span id="intro-black-heading">{props.headingBlack}</span>
      </h3>
      <div className="card-body small-font" id="intro-body">{props.body}</div>
    </div>
  );
};

IntroCards.propTypes = {
  headingBlack: PropTypes.string,
  headingRed: PropTypes.string,
  body: PropTypes.any,
};

export default IntroCards;
